import classNames from "classnames"
import { useState, useEffect } from "react"
import styles from "./activity-control.module.css"
import { Caret } from "@/common/icons/caret"
export const ActivityControl = ({ options, selected, callback }) => {
  const [open, setOpen] = useState(false)
  const [currentLabel, setCurrentLabel] = useState(false)
  const [currentIcon, setCurrentIcon] = useState(false)

  useEffect(() => {
    setCurrentIcon(selected?.icon?.content)
    setCurrentLabel(selected?.activity_name)
  }, [selected])

  return (
    <div
      className={classNames(styles.controller, {
        "is-open": open,
        "has-value": false
      })}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-label={open ? "Stäng" : "Öppna"}>
        {currentLabel && <Icon className="current-icon" svg={currentIcon} />}
        <span>{currentLabel}</span>

        <Caret className="caret" />
      </button>
      <ul className="activites">
        {options.map((item, index) => {
          return (
            <div key={index}>
              <label
                className={classNames("activity", {
                  "is-checked": item.activity_key === selected.key
                })}>
                <input
                  type="radio"
                  checked={item.activity_key === selected.key}
                  onChange={() => {
                    setCurrentIcon(item.icon.content)
                    setCurrentLabel(item.activity_name)
                    setOpen(false)
                    callback(item)
                  }}
                />
                <Icon className="shrink-0" svg={item.icon.content} />
                {item.activity}
                {item.title}
                <div>
                  <strong>{item.activity_name}</strong>
                  <p className="text-sm">{item.activity_description}</p>
                </div>
              </label>
            </div>
          )
        })}
      </ul>
    </div>
  )
}

const Icon = ({ svg, className }) => {
  return (
    <div
      className={classNames("icon", className)}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
